import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      duration={4000}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-red-600 group-[.toaster]:text-white group-[.toaster]:border-red-700 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-white",
          actionButton:
            "group-[.toast]:bg-white group-[.toast]:text-red-600",
          cancelButton:
            "group-[.toast]:bg-red-700 group-[.toast]:text-white",
          success: "group-[.toaster]:bg-red-600 group-[.toaster]:text-white",
          error: "group-[.toaster]:bg-red-600 group-[.toaster]:text-white",
          info: "group-[.toaster]:bg-red-600 group-[.toaster]:text-white",
          warning: "group-[.toaster]:bg-red-600 group-[.toaster]:text-white",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
